import { useTheme as useMUITheme } from '@mui/material';

export const useTheme = () => {
  const theme = useMUITheme();

  return theme;
};
